module.exports = __webpack_public_path__ + "media/Change.0c836d36.wav";